<template>
  <div
    class="dialogo dialogo_ativo dialogo_pequeno dialogo-de-situacao"
    role="dialog"
    aria-modal="true"
    :aria-label="dialogo.titulo"
    @click.self="fechar"
  >
    <form class="dialogo__container formulario" @submit.prevent="confirmar">
      <div class="dialogo__cabecalho dialogo-de-situacao__cabecalho">
        <h3 class="titulo titulo_medio dialogo-de-situacao__titulo">
          {{ dialogo.titulo }}
        </h3>
        <button
          type="button"
          class="dialogo__botao-fechar dialogo-de-situacao__botao-fechar"
          aria-label="Fechar"
          @click="fechar"
        >
          <i class="far fa-times" aria-hidden="true"></i>
        </button>
      </div>

      <div class="dialogo__corpo dialogo-de-situacao__corpo">
        <div class="dialogo-de-situacao__transicao">
          <span :class="['tags', 'tags_grande', classeDoTom(situacaoAtual)]">{{
            situacaoAtual
          }}</span>
          <i
            class="far fa-arrow-right dialogo-de-situacao__seta"
            aria-hidden="true"
          ></i>
          <span
            :class="['tags', 'tags_grande', classeDoTom(acao.proximaSituacao)]"
            >{{ acao.proximaSituacao }}</span
          >
        </div>

        <p class="texto texto_pequeno texto_cor-cinza u-margem-superior-mini">
          {{ dialogo.mensagem }}
        </p>

        <p v-if="dialogo.responsavel" class="dialogo-de-situacao__responsavel">
          <i
            class="far fa-user dialogo-de-situacao__icone-do-responsavel"
            aria-hidden="true"
          ></i>
          <span class="texto texto_medio"
            >Passa a ser responsável:
            <span class="u-texto-negrito">{{ dialogo.responsavel }}</span></span
          >
        </p>

        <div class="dialogo-de-situacao__campos">
          <div
            v-for="campo in dialogo.campos"
            :key="campo.chave"
            :class="[
              'dialogo-de-situacao__campo',
              { 'dialogo-de-situacao__campo_metade': campo.meiaLargura },
            ]"
          >
            <button
              v-if="campoEstaOculto(campo)"
              type="button"
              class="botao botao_sem-preenchimento botao_cor-terciaria botao_com-icone-para-esquerda dialogo-de-situacao__botao-expandir"
              @click="expandirCampo(campo.chave)"
            >
              <i class="far fa-plus" aria-hidden="true"></i>
              {{ campo.textoParaExibir || campo.rotulo }}
            </button>
            <template v-else>
              <label :for="idDoCampo(campo)" class="formulario__label">
                {{ campo.rotulo }}
                <span
                  v-if="campo.obrigatorio"
                  class="dialogo-de-situacao__obrigatorio"
                  aria-hidden="true"
                  >*</span
                >
              </label>

              <textarea
                v-if="campo.tipo === 'textarea'"
                :id="idDoCampo(campo)"
                v-model="valores[campo.chave]"
                :placeholder="campo.placeholder"
                :required="campo.obrigatorio"
                rows="4"
                class="formulario__textarea dialogo-de-situacao__textarea"
                :class="{ formulario__input_erro: erros[campo.chave] }"
              ></textarea>

              <input
                v-else-if="campo.tipo === 'data'"
                :id="idDoCampo(campo)"
                v-model="valores[campo.chave]"
                type="date"
                :max="campo.impedirDataFutura ? hoje : null"
                :required="campo.obrigatorio"
                class="formulario__input"
                :class="{ formulario__input_erro: erros[campo.chave] }"
              />

              <input
                v-else-if="campo.mascara"
                :id="idDoCampo(campo)"
                v-model="valores[campo.chave]"
                v-mask="campo.mascara"
                type="text"
                :placeholder="campo.placeholder"
                :required="campo.obrigatorio"
                class="formulario__input"
                :class="{ formulario__input_erro: erros[campo.chave] }"
              />

              <input
                v-else
                :id="idDoCampo(campo)"
                v-model="valores[campo.chave]"
                type="text"
                :placeholder="campo.placeholder"
                :required="campo.obrigatorio"
                class="formulario__input"
                :class="{
                  formulario__input_erro: erros[campo.chave],
                  'dialogo-de-situacao__input_maiusculo': campo.maiusculo,
                }"
              />

              <p
                v-if="erros[campo.chave]"
                class="formulario__mensagem formulario__mensagem_erro"
              >
                <i
                  class="far fa-exclamation-circle formulario__mensagem-icone"
                  aria-hidden="true"
                ></i>
                {{ erros[campo.chave] }}
              </p>
              <p v-else-if="campo.ajuda" class="dialogo-de-situacao__ajuda">
                {{ campo.ajuda }}
              </p>
            </template>
          </div>
        </div>
      </div>

      <div class="dialogo__rodape dialogo-de-situacao__rodape">
        <button
          type="submit"
          class="botao botao_medio"
          :class="classesDoBotaoDeConfirmacao"
          :disabled="carregando"
        >
          {{ dialogo.textoDeConfirmacao }}
        </button>
        <button
          type="button"
          class="botao botao_medio botao_cor-cinza botao_sem-preenchimento"
          @click="fechar"
        >
          Cancelar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import { obterTomDaSituacao } from "../controle-de-solicitacoes/detalhes-da-solicitacao/utils/fluxoDoBonusMoradia";

const CLASSES_DO_BOTAO_DE_CONFIRMACAO = {
  primaria: ["botao_cor-primaria"],
  "contorno-primaria": ["botao_cor-primaria", "botao_contorno"],
  "contorno-erro": ["botao_cor-perigo", "botao_contorno"],
};

export default {
  name: "dialogo-de-situacao",
  directives: { mask: AwesomeMask },
  props: {
    situacaoAtual: { type: String, required: true },
    acao: { type: Object, required: true },
    carregando: { type: Boolean, default: false },
  },
  data() {
    return {
      valores: {},
      erros: {},
      camposExpandidos: {},
    };
  },
  computed: {
    dialogo() {
      return this.acao.dialogo;
    },
    hoje() {
      return new Date().toISOString().slice(0, 10);
    },
    classesDoBotaoDeConfirmacao() {
      const estilo = this.dialogo.estiloDeConfirmacao || "primaria";
      return CLASSES_DO_BOTAO_DE_CONFIRMACAO[estilo];
    },
  },
  created() {
    this.preencherValoresIniciais();
  },
  mounted() {
    document.addEventListener("keydown", this.tratarTeclaPressionada);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.tratarTeclaPressionada);
  },
  methods: {
    preencherValoresIniciais() {
      const valores = {};

      this.dialogo.campos.forEach((campo) => {
        valores[campo.chave] = campo.preencherComHoje ? this.hoje : "";
      });

      this.valores = valores;
      this.camposExpandidos = {};
    },
    campoEstaOculto(campo) {
      return !!campo.ocultoPorPadrao && !this.camposExpandidos[campo.chave];
    },
    expandirCampo(chave) {
      this.$set(this.camposExpandidos, chave, true);
      this.$nextTick(() => {
        const elemento = document.getElementById(`${this.acao.chave}-${chave}`);
        if (elemento) elemento.focus();
      });
    },
    idDoCampo(campo) {
      return `${this.acao.chave}-${campo.chave}`;
    },
    classeDoTom(situacao) {
      return `tags_${obterTomDaSituacao(situacao)}`;
    },
    tratarTeclaPressionada(evento) {
      if (evento.key === "Escape") this.fechar();
    },
    validar() {
      const erros = {};

      this.dialogo.campos.forEach((campo) => {
        if (this.campoEstaOculto(campo)) return;

        const valor = (this.valores[campo.chave] || "").trim();

        if (campo.obrigatorio && !valor) {
          erros[campo.chave] = "Campo obrigatório";
          return;
        }

        if (
          campo.minimoDeCaracteres &&
          valor.length < campo.minimoDeCaracteres
        ) {
          erros[
            campo.chave
          ] = `Informe ao menos ${campo.minimoDeCaracteres} caracteres`;
          return;
        }

        if (valor && campo.padrao && !campo.padrao.test(valor)) {
          erros[campo.chave] = campo.mensagemDoPadrao || "Formato inválido";
          return;
        }

        if (valor && campo.impedirDataFutura && valor > this.hoje) {
          erros[campo.chave] = "A data não pode ser futura";
        }
      });

      this.erros = erros;
      return Object.keys(erros).length === 0;
    },
    montarValores() {
      const valores = {};

      this.dialogo.campos.forEach((campo) => {
        const valor = (this.valores[campo.chave] || "").trim();
        valores[campo.chave] = campo.maiusculo ? valor.toUpperCase() : valor;
      });

      return valores;
    },
    confirmar() {
      if (!this.validar()) return;
      this.$emit("confirmar", {
        acao: this.acao,
        valores: this.montarValores(),
      });
    },
    fechar() {
      this.$emit("fechar");
    },
  },
};
</script>



// WEBPACK FOOTER //
// DialogoDeSituacao.vue?e9f0f21a